import moment from 'moment'
import { useMemo } from 'react'

import { useDateFilter } from '../../../../dateFilter'
import useSelectOptions, {
  ISelectOptionsDataType,
} from '../../common/useSelectOptions'
import {
  IColumn,
  generateCsvColumnsForSelectedDow,
  generateTableColumnsForSelectedDow,
} from './generateColumns'
import { locationIntradaySelectOptions } from './locationIntradaySelectOptions'

export interface IDataType {
  intradayRevenueCenterMetricOptions?: ISelectOptionsDataType
  intradayDayOfWeekOptions?: ISelectOptionsDataType
  intradayHoursOptions?: ISelectOptionsDataType
  intradayTableColumns?: {
    price: IColumn[]
    number: IColumn[]
  }
  intradayCsvColumns?: {
    price: IColumn[]
    number: IColumn[]
  }
}

const useLocationIntradayConfigs = () => {
  const { selectOptions } = useSelectOptions(locationIntradaySelectOptions)
  const { startDate, endDate } = useDateFilter()
  const mStartDate = moment(startDate)
  const mEndDate = moment(endDate)

  const revenueCenterSelectorValue = selectOptions?.revenueCenterMetrics?.value
  const hoursSelectorValue = selectOptions?.hours?.value
  const dowSelectorValue = selectOptions?.dayOfWeek?.value

  let selectedMetricId: string = ''
  let selectedMetric: string = ''
  let metricDisplayType: string = ''
  if (
    Array.isArray(revenueCenterSelectorValue?.[0]) &&
    revenueCenterSelectorValue[0].length > 0
  ) {
    selectedMetricId =
      revenueCenterSelectorValue[0][revenueCenterSelectorValue[0].length - 1]
    const selectedValues = (selectedMetricId || '').split('|')
    selectedMetric = selectedValues[0] || ''
    metricDisplayType = selectedValues[1] || ''
  }

  const selectedHours: number[] = []
  if (Array.isArray(hoursSelectorValue) && hoursSelectorValue.length > 0) {
    hoursSelectorValue.forEach((valueArray) => {
      const hourValue = parseInt((valueArray?.[0] || '').replace('hour', ''))
      if (hourValue) {
        selectedHours.push(hourValue)
      }
    })
  }

  const selectedDayOfWeek: number[] = []
  if (Array.isArray(dowSelectorValue) && dowSelectorValue.length > 0) {
    dowSelectorValue.forEach((valueArray) => {
      const dowValue = parseInt((valueArray?.[0] || '').replace('dow', ''), 10)
      if (dowValue) {
        selectedDayOfWeek.push(dowValue)
      }
    })
  }

  return useMemo(
    () => ({
      intradayRevenueCenterMetricOptions: selectOptions?.revenueCenterMetrics,
      intradayDayOfWeekOptions: selectOptions?.dayOfWeek,
      intradayHoursOptions: selectOptions?.hours,
      intradayTableColumns: {
        price:
          metricDisplayType === 'price'
            ? generateTableColumnsForSelectedDow(
                selectedMetric,
                'price',
                mStartDate,
                mEndDate,
                selectedDayOfWeek,
                selectedHours,
              )
            : undefined,
        number:
          metricDisplayType === 'number'
            ? generateTableColumnsForSelectedDow(
                selectedMetric,
                'number',
                mStartDate,
                mEndDate,
                selectedDayOfWeek,
                selectedHours,
              )
            : undefined,
      },
      intradayCsvColumns: {
        price:
          metricDisplayType === 'price'
            ? generateCsvColumnsForSelectedDow(
                selectedMetricId,
                selectedMetric,
                'price',
                mStartDate,
                mEndDate,
                selectedDayOfWeek,
                selectedHours,
              )
            : undefined,
        number:
          metricDisplayType === 'number'
            ? generateCsvColumnsForSelectedDow(
                selectedMetricId,
                selectedMetric,
                'number',
                mStartDate,
                mEndDate,
                selectedDayOfWeek,
                selectedHours,
              )
            : undefined,
      },
    }),
    [selectOptions, selectedMetricId, selectedHours, selectedDayOfWeek],
  )
}

export default useLocationIntradayConfigs
